module.exports = "/virtual-football-league/img/video/clubs/england/chelsea.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/england/chelsea.png
// module id = 334
// module chunks = 4